module.exports = __webpack_public_path__ + "img/MZ.e74dcbf3.png";